import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { buildURLForMenuItem } from "../../utils/buildURL";
import Link from "../../utils/Link";
import { LanguageContext, text } from "../../container/language";
import Paragraph from "../Article/Paragraph";

export const UsefulLinks = ({ data }) => {
  const { links = [], column2, column3 } = data;
  const { t } = useTranslation();
  const { userLanguage } = useContext(LanguageContext);

  return (
    <div className="useful-links">
      <div className="useful-links">
        <div className="useful-links__row">
          <div className="useful-links__inner editable">
            <div className="useful-links__title">
              {t("usefulLinks.usefulLinks")}
            </div>
            <ul className="useful-links__list">
              {links.map((item) => {
                const url = buildURLForMenuItem(item);

                if (url.startsWith("http")) {
                  return (
                    <li>
                      <a href={url} target="_blank">
                        {text(item.label, userLanguage)}
                      </a>
                    </li>
                  );
                } else {
                  return (
                    <li>
                      <Link to={url}>{text(item.label, userLanguage)}</Link>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </div>
        <div className="useful-links__row">
          <div className="useful-links__inner editable">
            <div className="useful-links__title">
              {text(column2.title, userLanguage)}
            </div>

            <small>
              <Paragraph data={column2.body} />
            </small>
          </div>
        </div>
        <div className="useful-links__row">
          <div className="useful-links__inner editable">
            <div className="useful-links__title">
              {text(column3.title, userLanguage)}
            </div>
            <small>
              <Paragraph data={column3.body} />
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};
